import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const FLAGGED_ENTRIES_NOT_ACKNOWLEDGED = "zz_SourcingEventApiErrorCode_FlaggedEntriesNotAcknowledged";

export const isFlaggedEntriesRefusal = (e: unknown): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === FLAGGED_ENTRIES_NOT_ACKNOWLEDGED;
